import * as DropdownMenu from '@radix-ui/react-dropdown-menu'

import { AddSquare } from 'common/icons'

type Props = {
  onSelect?: () => void
}

const AddIntegrationButton = ({ onSelect }: Props) => {
  return (
    <DropdownMenu.Item
      onSelect={onSelect}
      className="flex items-center p-4 -mx-4 cursor-pointer hover:bg-gold-300 outline-none"
    >
      <AddSquare isDefaultColor={false} size={4} className="text-base-700" />
      <span className="font-medium text-base-700 text-sm uppercase ml-1">
        Add integration
      </span>
    </DropdownMenu.Item>
  )
}

export default AddIntegrationButton
